// src/pages/CRNADemoPage.js
import React from 'react';
import { Container } from 'react-bootstrap';
import SwipeableProfiles from '../components/SwipeableProfiles';
import { sampleProfiles } from './sampleProfiles';

const CRNADemoPage = ({ modal = false }) => (
  <Container
    className="d-flex flex-column justify-content-center align-items-center"
    style={{
      minHeight: modal ? 'auto' : '100vh',
      paddingTop: modal ? '0px' : '60px',
      paddingBottom: modal ? '0px' : '60px',
    }}
  >
    {!modal && (
      <h2 className="mb-4 text-center">Wake Up to Better CRNA Matches</h2>
    )}
    <SwipeableProfiles profiles={sampleProfiles} />
  </Container>
);

export default CRNADemoPage;
